<script setup>

import localise from "../../lang/localize.json";
import {ref, watch} from "vue";

const props = defineProps({
  lang: {
    type: String,
    default: 'de'
  },
  newpostext:{
    type:String,
    default:'new line'
  },
  header:{
    type: String
  },
  subheader:{
    type: String
  }
})

const emits = defineEmits(['makeposition','updatetextvalue'])

const posListItems = ref([])
const setpospos = ref(5)
const setposqty = ref(1)
const setpostext = ref(props.newpostext)

const header = props.header || localise.section_header_select_products[props.lang]
const subheader = props.subheader || localise.section_header_selected_products[props.lang]

watch(() => props.newpostext, (newText) => {
  setpostext.value = newText;
  // emits('updatetextvalue', setpostext.value);
});

const addPos = () => {

  posListItems.value.push({
    pos: setpospos.value,
    qty: setposqty.value,
    postext: setpostext.value
  })

  emits('makeposition',{
    pos: setpospos.value,
    qty: setposqty.value,
    postext: setpostext.value
  })

  nextPos()

}

const nextPos = () =>{
  setposqty.value = 1;
  setpostext.value = '';
  setpospos.value = setpospos.value * 1 + 5;
}

const removePositem = (pos) => {

  const index = posListItems.value.findIndex((i) => {
    return i.pos === pos;
  })

  posListItems.value.splice(index, 1);

  if (posListItems.value.length === 0) setpospos.value = 5;

  // validate()
}

</script>

<template>
  <main class="low-root">
    <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
        <h3 class="text-lg ">{{ header }}</h3>
        <table class="min-w-full">
          <tr class="bg-slate-50">
            <th class="w-14 pt-3.5 pl-4 pr-3 text-sm font-semibold text-slate-900 sm:pl-0 text-center"
                scope="col"
            >{{ localise.table_material_header_pos[lang] }}
            </th>
            <th class=" w-16 pt-3.5 pr-3 text-sm font-semibold text-slate-900 text-center"
                scope="col"
            >{{ localise.table_material_header_qty[lang] }}
            </th>
            <th class="pt-3.5 pr-3 text-left text-sm font-semibold text-slate-900"
                scope="col"
            >{{ localise.table_material_header_mat[lang] }}
            </th>
            <th scope="col"></th>
          </tr>
          <tr class="bg-slate-50 border-b-2">
            <td class="w-14 px-3 pb-2">
              <input v-model="setpospos"
                     class="w-14 text-center input-md"
                     type="text"
                     name="setPositionNumber"
                     :aria-label="localise.input_aria_label_newpos_number[lang]"
              >
            </td>
            <td class="w-16 px-3 pb-2">
              <input v-model="setposqty"
                     class="w-16 text-center input-md"
                     placeholder="1"
                     type="text"
                     name="setPositionQuantity"
                     :aria-label="localise.input_aria_label_newpos_quantity[lang]"
              >
            </td>
            <td class="pb-2">
              <input v-model="setpostext"
                     class="w-full input-md"
                     :placeholder="localise.input_placeholder_find_in_database[lang]"
                     type="text"
                     name="setPositionText"
                     :aria-label="localise.input_aria_label_newpos_text[lang]"
              >
            </td>
            <td class="w-12 text-center pb-2">
              <button class="button-add"
                      type="button"
                      @click="addPos()"
                      :aria-label="localise.btn_aria_label_add_position[lang]"
              >
                <svg class="w-7 h-7 sm:w-6 sm:h-6 text-red-500"
                     viewBox="0 0 448 512"
                     xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M240 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H176V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H240V80z"
                        style="fill:currentColor"
                  />
                </svg>
              </button>
            </td>
          </tr>
        </table>

        <h3 class="text-lg ">{{ subheader }}</h3>
        <table class="min-w-full">
          <tr v-show="posListItems.length===0">
            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium sm:pl-0 text-center"
                colspan="4"
            >{{ localise.msg_empty_mat_table[lang] }}
            </td>
          </tr>
          <tr v-for="positem in posListItems"
              :key="positem.pos"
          >
            <td class="w-12 px-3 py-1.5">
              <input :id="`pos-${positem.pos}`"
                     :value="positem.pos"
                     class="mt-1 block w-14 text-center input-md"
                     name="pos[]"
                     type="text"
              >
            </td>
            <td class="w-16 pr-3 py-1.5">
              <input :id="`qty-${positem.pos}`"
                     :value="positem.qty"
                     class="mt-1 block w-16 text-center input-md"
                     name="qty[]"
                     type="text"
              >
            </td>
            <td class=" py-1.5">
              <input :id="`postext-${positem.pos}`"
                     :value="positem.postext"
                     class="mt-1 block w-full input-md"
                     name="postext[]"
                     type="text"
              >
            </td>
            <td class="w-12 text-center py-1.5">
              <button class="button-set mx-auto mt-1"
                      type="button"
                      @click="removePositem(positem.pos)"
                      :aria-label="localise.btn_aria_label_remove_position[lang]"
              >
                <svg class="w-3 h-3 sm:w-4 sm:h-4 text-red-500"
                     viewBox="0 0 448 512"
                     xmlns="http://www.w3.org/2000/svg"
                ><!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                  <path d="M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                        style="fill:currentColor"
                  />
                </svg>
              </button>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </main>
</template>

<style scoped>

</style>